import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Organisations
 */ import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  DeleteOrgPreferenceResponse,
  ErrorResponse,
  GetOrgPreferenceResponse,
  MessageResponse,
  PMPreference,
  SaveOrgPreferenceRequest,
  SaveOrgPreferenceResponse,
  SaveUserPmPreferenceRequest,
  ValidationErrorResponse,
} from "../models";

import { restFetch } from "../../../../shell/api/auth.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type saveUserPmPreferenceResponse200 = {
  data: MessageResponse;
  status: 200;
};

export type saveUserPmPreferenceResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type saveUserPmPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type saveUserPmPreferenceResponse422 = {
  data: ValidationErrorResponse;
  status: 422;
};

export type saveUserPmPreferenceResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type saveUserPmPreferenceResponseSuccess =
  saveUserPmPreferenceResponse200 & {
    headers: Headers;
  };
export type saveUserPmPreferenceResponseError = (
  | saveUserPmPreferenceResponse400
  | saveUserPmPreferenceResponse401
  | saveUserPmPreferenceResponse422
  | saveUserPmPreferenceResponse500
) & {
  headers: Headers;
};

export type saveUserPmPreferenceResponse =
  | saveUserPmPreferenceResponseSuccess
  | saveUserPmPreferenceResponseError;

export const getSaveUserPmPreferenceUrl = () => {
  return `/api/v1/users/me/pm-preference`;
};

/**
 * @summary Save PM preference for current user
 */
export const saveUserPmPreference = async (
  saveUserPmPreferenceRequest: SaveUserPmPreferenceRequest,
  options?: RequestInit,
): Promise<saveUserPmPreferenceResponse> => {
  return restFetch<saveUserPmPreferenceResponse>(getSaveUserPmPreferenceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveUserPmPreferenceRequest),
  });
};

export const getSaveUserPmPreferenceMutationOptions = <
  TError = ErrorResponse | ValidationErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveUserPmPreference>>,
    TError,
    { data: SaveUserPmPreferenceRequest },
    TContext
  >;
  request?: SecondParameter<typeof restFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveUserPmPreference>>,
  TError,
  { data: SaveUserPmPreferenceRequest },
  TContext
> => {
  const mutationKey = ["saveUserPmPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveUserPmPreference>>,
    { data: SaveUserPmPreferenceRequest }
  > = props => {
    const { data } = props ?? {};

    return saveUserPmPreference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveUserPmPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveUserPmPreference>>
>;
export type SaveUserPmPreferenceMutationBody = SaveUserPmPreferenceRequest;
export type SaveUserPmPreferenceMutationError =
  | ErrorResponse
  | ValidationErrorResponse;

/**
 * @summary Save PM preference for current user
 */
export const useSaveUserPmPreference = <
  TError = ErrorResponse | ValidationErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveUserPmPreference>>,
      TError,
      { data: SaveUserPmPreferenceRequest },
      TContext
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveUserPmPreference>>,
  TError,
  { data: SaveUserPmPreferenceRequest },
  TContext
> => {
  return useMutation(
    getSaveUserPmPreferenceMutationOptions(options),
    queryClient,
  );
};
export type getUserPmPreferenceResponse200 = {
  data: PMPreference;
  status: 200;
};

export type getUserPmPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getUserPmPreferenceResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type getUserPmPreferenceResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type getUserPmPreferenceResponseSuccess =
  getUserPmPreferenceResponse200 & {
    headers: Headers;
  };
export type getUserPmPreferenceResponseError = (
  | getUserPmPreferenceResponse401
  | getUserPmPreferenceResponse404
  | getUserPmPreferenceResponse500
) & {
  headers: Headers;
};

export type getUserPmPreferenceResponse =
  | getUserPmPreferenceResponseSuccess
  | getUserPmPreferenceResponseError;

export const getGetUserPmPreferenceUrl = (organisationId: string) => {
  return `/api/v1/users/me/pm-preference/${organisationId}`;
};

/**
 * @summary Get current user's PM preference
 */
export const getUserPmPreference = async (
  organisationId: string,
  options?: RequestInit,
): Promise<getUserPmPreferenceResponse> => {
  return restFetch<getUserPmPreferenceResponse>(
    getGetUserPmPreferenceUrl(organisationId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetUserPmPreferenceQueryKey = (organisationId: string) => {
  return [`/api/v1/users/me/pm-preference/${organisationId}`] as const;
};

export const getGetUserPmPreferenceQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPmPreference>>,
  TError = ErrorResponse,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPmPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserPmPreferenceQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPmPreference>>
  > = ({ signal }) =>
    getUserPmPreference(organisationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: organisationId !== null && organisationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPmPreference>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserPmPreferenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPmPreference>>
>;
export type GetUserPmPreferenceQueryError = ErrorResponse;

export function useGetUserPmPreference<
  TData = Awaited<ReturnType<typeof getUserPmPreference>>,
  TError = ErrorResponse,
>(
  organisationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPmPreference>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPmPreference>>,
          TError,
          Awaited<ReturnType<typeof getUserPmPreference>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPmPreference<
  TData = Awaited<ReturnType<typeof getUserPmPreference>>,
  TError = ErrorResponse,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPmPreference>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPmPreference>>,
          TError,
          Awaited<ReturnType<typeof getUserPmPreference>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPmPreference<
  TData = Awaited<ReturnType<typeof getUserPmPreference>>,
  TError = ErrorResponse,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPmPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current user's PM preference
 */

export function useGetUserPmPreference<
  TData = Awaited<ReturnType<typeof getUserPmPreference>>,
  TError = ErrorResponse,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPmPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserPmPreferenceQueryOptions(
    organisationId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteUserPmPreferenceResponse204 = {
  data: void;
  status: 204;
};

export type deleteUserPmPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type deleteUserPmPreferenceResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type deleteUserPmPreferenceResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type deleteUserPmPreferenceResponseSuccess =
  deleteUserPmPreferenceResponse204 & {
    headers: Headers;
  };
export type deleteUserPmPreferenceResponseError = (
  | deleteUserPmPreferenceResponse401
  | deleteUserPmPreferenceResponse404
  | deleteUserPmPreferenceResponse500
) & {
  headers: Headers;
};

export type deleteUserPmPreferenceResponse =
  | deleteUserPmPreferenceResponseSuccess
  | deleteUserPmPreferenceResponseError;

export const getDeleteUserPmPreferenceUrl = (organisationId: string) => {
  return `/api/v1/users/me/pm-preference/${organisationId}`;
};

/**
 * @summary Delete current user's PM preference
 */
export const deleteUserPmPreference = async (
  organisationId: string,
  options?: RequestInit,
): Promise<deleteUserPmPreferenceResponse> => {
  return restFetch<deleteUserPmPreferenceResponse>(
    getDeleteUserPmPreferenceUrl(organisationId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteUserPmPreferenceMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserPmPreference>>,
    TError,
    { organisationId: string },
    TContext
  >;
  request?: SecondParameter<typeof restFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserPmPreference>>,
  TError,
  { organisationId: string },
  TContext
> => {
  const mutationKey = ["deleteUserPmPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserPmPreference>>,
    { organisationId: string }
  > = props => {
    const { organisationId } = props ?? {};

    return deleteUserPmPreference(organisationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserPmPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserPmPreference>>
>;

export type DeleteUserPmPreferenceMutationError = ErrorResponse;

/**
 * @summary Delete current user's PM preference
 */
export const useDeleteUserPmPreference = <
  TError = ErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUserPmPreference>>,
      TError,
      { organisationId: string },
      TContext
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserPmPreference>>,
  TError,
  { organisationId: string },
  TContext
> => {
  return useMutation(
    getDeleteUserPmPreferenceMutationOptions(options),
    queryClient,
  );
};
export type saveUserOrgPreferenceResponse200 = {
  data: SaveOrgPreferenceResponse;
  status: 200;
};

export type saveUserOrgPreferenceResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type saveUserOrgPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type saveUserOrgPreferenceResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type saveUserOrgPreferenceResponse422 = {
  data: ValidationErrorResponse;
  status: 422;
};

export type saveUserOrgPreferenceResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type saveUserOrgPreferenceResponseSuccess =
  saveUserOrgPreferenceResponse200 & {
    headers: Headers;
  };
export type saveUserOrgPreferenceResponseError = (
  | saveUserOrgPreferenceResponse400
  | saveUserOrgPreferenceResponse401
  | saveUserOrgPreferenceResponse404
  | saveUserOrgPreferenceResponse422
  | saveUserOrgPreferenceResponse500
) & {
  headers: Headers;
};

export type saveUserOrgPreferenceResponse =
  | saveUserOrgPreferenceResponseSuccess
  | saveUserOrgPreferenceResponseError;

export const getSaveUserOrgPreferenceUrl = () => {
  return `/api/v1/users/me/org-preference`;
};

/**
 * @summary Save org preference for current user
 */
export const saveUserOrgPreference = async (
  saveOrgPreferenceRequest: SaveOrgPreferenceRequest,
  options?: RequestInit,
): Promise<saveUserOrgPreferenceResponse> => {
  return restFetch<saveUserOrgPreferenceResponse>(
    getSaveUserOrgPreferenceUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(saveOrgPreferenceRequest),
    },
  );
};

export const getSaveUserOrgPreferenceMutationOptions = <
  TError = ErrorResponse | ValidationErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveUserOrgPreference>>,
    TError,
    { data: SaveOrgPreferenceRequest },
    TContext
  >;
  request?: SecondParameter<typeof restFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveUserOrgPreference>>,
  TError,
  { data: SaveOrgPreferenceRequest },
  TContext
> => {
  const mutationKey = ["saveUserOrgPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveUserOrgPreference>>,
    { data: SaveOrgPreferenceRequest }
  > = props => {
    const { data } = props ?? {};

    return saveUserOrgPreference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveUserOrgPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveUserOrgPreference>>
>;
export type SaveUserOrgPreferenceMutationBody = SaveOrgPreferenceRequest;
export type SaveUserOrgPreferenceMutationError =
  | ErrorResponse
  | ValidationErrorResponse;

/**
 * @summary Save org preference for current user
 */
export const useSaveUserOrgPreference = <
  TError = ErrorResponse | ValidationErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveUserOrgPreference>>,
      TError,
      { data: SaveOrgPreferenceRequest },
      TContext
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveUserOrgPreference>>,
  TError,
  { data: SaveOrgPreferenceRequest },
  TContext
> => {
  return useMutation(
    getSaveUserOrgPreferenceMutationOptions(options),
    queryClient,
  );
};
export type getUserOrgPreferenceResponse200 = {
  data: GetOrgPreferenceResponse;
  status: 200;
};

export type getUserOrgPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getUserOrgPreferenceResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type getUserOrgPreferenceResponseSuccess =
  getUserOrgPreferenceResponse200 & {
    headers: Headers;
  };
export type getUserOrgPreferenceResponseError = (
  | getUserOrgPreferenceResponse401
  | getUserOrgPreferenceResponse500
) & {
  headers: Headers;
};

export type getUserOrgPreferenceResponse =
  | getUserOrgPreferenceResponseSuccess
  | getUserOrgPreferenceResponseError;

export const getGetUserOrgPreferenceUrl = () => {
  return `/api/v1/users/me/org-preference`;
};

/**
 * @summary Get current user's org preference
 */
export const getUserOrgPreference = async (
  options?: RequestInit,
): Promise<getUserOrgPreferenceResponse> => {
  return restFetch<getUserOrgPreferenceResponse>(getGetUserOrgPreferenceUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUserOrgPreferenceQueryKey = () => {
  return [`/api/v1/users/me/org-preference`] as const;
};

export const getGetUserOrgPreferenceQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserOrgPreference>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserOrgPreference>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserOrgPreferenceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserOrgPreference>>
  > = ({ signal }) => getUserOrgPreference({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserOrgPreference>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserOrgPreferenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserOrgPreference>>
>;
export type GetUserOrgPreferenceQueryError = ErrorResponse;

export function useGetUserOrgPreference<
  TData = Awaited<ReturnType<typeof getUserOrgPreference>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserOrgPreference>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserOrgPreference>>,
          TError,
          Awaited<ReturnType<typeof getUserOrgPreference>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserOrgPreference<
  TData = Awaited<ReturnType<typeof getUserOrgPreference>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserOrgPreference>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserOrgPreference>>,
          TError,
          Awaited<ReturnType<typeof getUserOrgPreference>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserOrgPreference<
  TData = Awaited<ReturnType<typeof getUserOrgPreference>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserOrgPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current user's org preference
 */

export function useGetUserOrgPreference<
  TData = Awaited<ReturnType<typeof getUserOrgPreference>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserOrgPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserOrgPreferenceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteUserOrgPreferenceResponse200 = {
  data: DeleteOrgPreferenceResponse;
  status: 200;
};

export type deleteUserOrgPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type deleteUserOrgPreferenceResponse500 = {
  data: ErrorResponse;
  status: 500;
};

export type deleteUserOrgPreferenceResponseSuccess =
  deleteUserOrgPreferenceResponse200 & {
    headers: Headers;
  };
export type deleteUserOrgPreferenceResponseError = (
  | deleteUserOrgPreferenceResponse401
  | deleteUserOrgPreferenceResponse500
) & {
  headers: Headers;
};

export type deleteUserOrgPreferenceResponse =
  | deleteUserOrgPreferenceResponseSuccess
  | deleteUserOrgPreferenceResponseError;

export const getDeleteUserOrgPreferenceUrl = () => {
  return `/api/v1/users/me/org-preference`;
};

/**
 * @summary Delete current user's org preference
 */
export const deleteUserOrgPreference = async (
  options?: RequestInit,
): Promise<deleteUserOrgPreferenceResponse> => {
  return restFetch<deleteUserOrgPreferenceResponse>(
    getDeleteUserOrgPreferenceUrl(),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteUserOrgPreferenceMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserOrgPreference>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof restFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserOrgPreference>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteUserOrgPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserOrgPreference>>,
    void
  > = () => {
    return deleteUserOrgPreference(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserOrgPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserOrgPreference>>
>;

export type DeleteUserOrgPreferenceMutationError = ErrorResponse;

/**
 * @summary Delete current user's org preference
 */
export const useDeleteUserOrgPreference = <
  TError = ErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUserOrgPreference>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof restFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserOrgPreference>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getDeleteUserOrgPreferenceMutationOptions(options),
    queryClient,
  );
};
